import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// What a submitted test is, at the top of its review: the instrument, its
// version and language, when it was submitted and how much was answered,
// whether the clinician has reviewed it, and the scores by the published
// rules, with no label or interpretation.
export function ReviewSummary({ attempt }) {
  const { text, language } = useLanguage();
  const { questionnaire, submittedAt, answered, total, subscales, reviewedAt } = attempt;
  const submitted = new Intl.DateTimeFormat(language, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(submittedAt));
  const meta = [
    questionnaire.version,
    text.languageNames[ questionnaire.language ],
    text.submittedAt.replace('{date}', submitted),
    text.answeredOf.replace('{answered}', answered).replace('{total}', questionnaire.items.length)
  ];

  let chip = <span className={ `${ styles.chip } ${ styles.pending }` }>{ text.notReviewed }</span>;

  if (reviewedAt != null) {
    chip = <span className={ styles.chip }>{ text.reviewedOn.replace('{date}', describe({ day: dayOf(reviewedAt), language, short: true })) }</span>;
  }

  const scores = [ { name: text.totalScore, score: total } ].concat(subscales).map(function({ name, score }) {
    return (
      <div key={ name } className={ styles.score }>
        <dt className={ styles.scoreName }>{ name }</dt>
        <dd className={ styles.scoreValue }>{ score }</dd>
      </div>
    );
  });

  return (
    <div className={ styles.summary }>
      <div className={ styles.top }>
        <div className={ styles.lines }>
          <h2 className={ styles.title }>{ questionnaire.name }</h2>
          <span className={ styles.meta }>{ meta.join(' · ') }</span>
        </div>

        { chip }
      </div>

      <dl className={ styles.scores } aria-label={ text.scores }>{ scores }</dl>
    </div>
  );
}
